// Daypart vocabulary — must match backend/services/mealPeriods.js and the database
// check constraint added in 20260731000000_cafeteriaos_integration.js.
//
// Records created before this dimension existed carry no meal period; UNSPECIFIED is the
// filter value that selects them, so unattributed demand and production stay visible
// rather than disappearing from a filtered report.

export const MEAL_PERIODS = ['Breakfast', 'Lunch', 'Snacks', 'Dinner', 'Night Shift'];

export const UNSPECIFIED = 'Unspecified';

// Options for a filter dropdown: All + the four dayparts + Unspecified.
export const MEAL_PERIOD_FILTER_OPTIONS = [
  { value: 'ALL', label: 'All Meal Periods' },
  ...MEAL_PERIODS.map((m) => ({ value: m, label: m })),
  { value: UNSPECIFIED, label: 'Unspecified' },
];

export function mealPeriodLabel(value) {
  return value || UNSPECIFIED;
}
